import { format, parseJSON } from "date-fns";

export type GroupPeriod = "month" | "year";

export interface MonthGroup<T> {
  key: string;
  date: Date;
  items: T[];
}

export const groupByMonth = <T>(
  items: T[],
  getDate: (item: T) => string,
  getId: (item: T) => string | number,
  period: GroupPeriod = "month"
): MonthGroup<T>[] => {
  const seen = new Set<string | number>();

  return items.reduce<MonthGroup<T>[]>((months, item) => {
    const id = getId(item);
    if (seen.has(id)) return months;
    seen.add(id);

    const date = parseJSON(getDate(item));
    const key = format(date, period === "year" ? "yyyy" : "yyyy-MM");
    const current = months[months.length - 1];
    if (current?.key === key) {
      current.items.push(item);
    } else {
      months.push({ key, date, items: [item] });
    }
    return months;
  }, []);
};
